<template>
  <span :class="classes"> {{ textToShow }} </span>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import type { TBadgeVarianten } from '@/design-system/atoms/TBadge/types';
import { TBadgeSize, TBadgeVariantenDefaultText } from '@/design-system/atoms/TBadge/types';

interface Props {
  variante: TBadgeVarianten;
  text?: string;
  size?: TBadgeSize;
}

const props = withDefaults(defineProps<Props>(), {
  text: '',
  size: TBadgeSize.MEDIUM,
});

const textToShow = computed(() => {
  if (TBadgeVariantenDefaultText[props.variante] !== undefined && props.text === '') {
    return TBadgeVariantenDefaultText[props.variante];
  }

  return props.text;
});

const classes = computed(() => `t-badge t-badge--${props.variante} t-badge--${props.size}`);
</script>
